var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scrollbar-horizontal"},[(_vm.width < 100)?_c('div',{ref:"container",staticClass:"vue-scrollbar__scrollbar-horizontal",on:{"click":_vm.jump}},[_c('div',{ref:"scrollbar",class:'scrollbar' + (_vm.dragging || _vm.draggingFromParent ? '' : ' vue-scrollbar-transition'),style:({
				width: _vm.width + '%',
				left: _vm.scrolling + '%',
			}),on:{"touchstart":_vm.startDrag,"mousedown":_vm.startDrag,"click":function($event){$event.stopPropagation();return (() => {}).apply(null, arguments)}}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }